// extracted by mini-css-extract-plugin
module.exports = {"admin-area":"Admin_admin-area__qI3Sj","admin-form":"Admin_admin-form__1HZan","enterprise-list":"Admin_enterprise-list__2m8U1","table-area":"Admin_table-area__2v-Ef"};